import React, { Component } from "react";
import ReactDOM from "react-dom";
import posed, { PoseGroup } from "react-pose";
import SplitText from "react-pose-text";
import "./slideshow.css";

const Modal = posed.div({
    enter: {
      y: 0,
      opacity: 1,
      beforeChildren: true,
      staggerChildren: 1,
      delay: 10,
      transition: {
        y: { type: "spring", stiffness: 1000, damping: 10 },
        default: { duration: 10 }
      }
    },
    exit: {
      y: 50,
      opacity: 0,
      transition: { duration: 10 }
    }
  });
  
  const Shade = posed.div({
    enter: { opacity: 1 },
    exit: { opacity: 0 },
    transition: {
      default: { duration: 10 }
    }
  });
  
  const charPoses = {
    exit: { opacity: 0, x: 20 },
    enter: {
      opacity: 1,
      x: 0
    }
  };
  
  class App extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isVisible: true,
        headertxt: [
            "Verglasungswahn!",
            "Grundwasserverseuchung im Eichkamp / Berlin",
            "Behinderung der Nutzung des Fernwärmerücklaufs",
            "Konsequenzen der Absenkung der maximal zulässigen Rücklauftemperaturen",
            "Die Berliner Verwaltungen sind nicht in der Lage ihre Aufgaben im Sinne des Klimaschutz zu erfüllen",
            "Energetische Verschwendung von Umweltenergie im Blumenviertel - Berlin",
            "Kein Tempolimit zur Bedienung einer Wählerminderheit (CDU/CSU, FDP & AFD)"
        ],
        slides: [
          "Das Gebäudeenergiegesetz (GEG) lässt immer noch Energieschleudern zu: Das Referenzgebäudeverfahren nach GEG sieht keinerlei Einschränkungen bei den Verglasungsflächen vor. Der Heizwärmebedarf eines Gebäudes mit Glasfassaden ist je nach Größe und Nutzung 50% bis über 100% gegenüber einem Gebäude mit 30 % Fensteranteil in der Fassade erhöht. Hinzu kommt die deutlich größere sommerliche Überhitzung, die durch Sonnenschutzmaßnahmen nur eingeschränkt abgemindert werden kann und dadurch den Kühlenergiebedarf anhebt.",
          "Seit Jahrzehnten treibt vom ehemaligen Güterbahnhof Grunewald der Deutschen Bahn eine Altlastenfahne unter dem Eichkamp Richtung der Trinkwasserbrunnen Rupenhorn und Tiefwerder, die teilweise Konzentrationen um 10erPotenzen oberhalb des Sanierungsschwellwerts in dem Siedlungsgebiet aufweist, dass vom Betrieb von Gartenbrunnen aus gesundheitlichen Gründen abgeraten wird. Dem Argument zu großer Kosten für eine Altlastensanierung könnte hier durch Nutzung der Grundwasserwärme als Quelle für Wärmepumpen begegnet werden. Damit wäre sowohl eine Umweltenergiequelle für die überfällige energetische Nutzung des Quartiers als auch die durch die Europäische Wasserrahmenrichtlinie gesetzlich verankerte Pflicht zur Verbesserung der Grundwasserqualität entsprochen werden.",
          "Insbesondere im Neubaubereich oder auch im Bestand, u.U. unter Einsatz von Wärmepumpen, könnte die Nutzung des Fernwärmerücklaufs und die bessere energetische Nutzung im Erzeugerpark beitragen. Allerdings werden bei Vattenfall Berlin die Anschlusskosten an den Rücklauf mit dem gleichen Preisblatt versehen, wie der Anschluss an den Vorlauf. Eine Stimulierung bzw. Förderung dieser Art von Fernwärmenutzung wird somit verhindert.",
          "In den aktuellen TAB der SW Potsdam werden für die Rücklaufeinspeisung Temperaturen unterhalb 30°C gefordert. Um diese niedrigen Temperaturen zur erreichen müssen Niedrigtemperaturheizungen (z.B. Flächenheizsysteme) zum Einsatz kommen und im Sommer, wo nur Trinkwasser bereitet wird, z.B. durch Speichersysteme die Wärmemengen mit entsprechenden Temperaturen zur Deckung der Zirkulationsverluste in Zeiten ohne Zapfung vorgehalten werden. In der Regel wird das nicht gelingen, so dass verbraucherseitig nur durch Einsatz von Wärmepumpen diese Rücklaufabsenkung gelingen kann. Damit bleibt es beim Nutzer nicht nur bei den Anschlusskosten, sondern es kommen weitere Installationen und Betriebskosten zu den Fernwärmepreisen hinzu.",
          "Es fehlt ein Leistungsprinzip und es kommt zur Konfrontation zwischen den Ansprüchen des Senats und der Umsetzungsfähigkeit/-bereitschaft in den Bezirken. Einerseits werden fehlende Personal- und Finanzmittel angeführt, andererseits gibt es immer wieder Hinweise dass anders priorisiert und/oder die nötige Motivation in den Bezirken fehlt, was rechtfertigen würde, die Bezirke in Folge des Klimanotstand von den notwendigen Entscheidungen zu entbinden. Da aber ein solch rigoroser Umbau der Verwaltung seit Jahrzehnten gescheitert ist (Stein-Hardenbergsche Reformen, Groß- Berlin-Gesetz 1920, Entbürokratisierungskampagnen) kann man nur versuchen, in überschaubaren Bereichen anzufangen und von Bezirken, die sich nicht angemessen beteiligen, Mittel auf andere Bezirke umzuschichten. Gern sammeln wir Hinweise welche Bezirke bzw. Abteilungen sperrig erlebt werden, um an die Betreffenden heranzutreten und zu unterstützen.",
          "Die Jahrzehnte praktizierte Grundwasserabsenkung zur Gebäudetrockenhaltung mit Dauerableitung erheblicher Grundwassermengen in das Oberflächengewässer wurde bislang von den Berliner Wasserbetrieben, bzw. deren Kunden finanziert und stellt dabei eine ergiebige Umweltwärmequelle dar, die zur Speisung von dezentralen Wärmepumpen in dem fossil beheizten Einfamilienhausquartier sehr einfach nutzbar wäre und das System teilweise sogar amortisieren könnte. Sowohl die Anrainer, als auch der RBB (der die nassen Keller immer wieder medial inszeniert) und der Umweltsenat waren bislang leider an einer solchen Lösung nicht interessiert.",
          "Laut einer Studie des Umweltbundesamtes vom Februar 2020 ließen sich mit einem generellen Tempolimit von 130 km/h auf deutschen Autobahnen zwischen 1,9 und 2,2 Millionen Tonnen CO2-Äquivalente pro Jahr, das wären rund 2% der Emissionen des Gebäudesektors, einsparen. Gemessen an den Einsparungszielen im Verkehrssektor von 2030, macht ein Tempolimit von 130 km/h 2,4 Prozent der einzusparenden Menge, Tempo 120 3,2 Prozent und Tempo 100 knapp sieben Prozent der einzusparenden Emissionen aus. Eine solche Maßnahme wäre nicht nur kostenlos, sondern würde im Gegenteil individuell erheblich Kosten einsparen und angesichts der aktuellen Energieverknappung auch dazu beitragen unsere Abhängigkeit von Energieimporten zu senken. Ein Tempolimit ist daher als enorm effektiv zu bewerten. Die Mehrheit der Bevölkerung ist zwar für ein Tempolimit, dennoch scheint es zur Bedienung bestimmter Gruppen in der Wählerschaft opportun zu sein, kein generelles Tempolimit einzuführen."
        ],
        currentSlide: 0,
        slideTimer: 1 * 10000
      };
    }
    componentDidMount() {
      setInterval(() => {
        this.changeSlide();
      }, 15000);
    }
    changeSlide() {
      let { slides, currentSlide } = this.state;
      //4
      let nextSlide = slides.length - 1 > currentSlide ? currentSlide + 1 : 0;
      // let nextSlide = currentSlide + 1;
      console.log(currentSlide, nextSlide);
  
      this.setState({ isVisible: false, currentSlide: nextSlide });
      const that = this;
      setTimeout(function() {
        that.setState({ isVisible: true });
      }, 500);
    }
    render() {
      let { isVisible, headertxt, slides, currentSlide } = this.state;
  
      return (
        <div className="container" onClick={this.changeSlide.bind(this)}>
          <PoseGroup>
            {isVisible && [
              <Shade key="shade" className="shade" />,
              <Modal key="modal" className="modal">
                <h1><SplitText charPoses={charPoses}>
                    {headertxt[currentSlide]}
                  </SplitText></h1>
                <p>
                  <SplitText charPoses={charPoses}>
                    {slides[currentSlide]}
                  </SplitText>
                </p>
              </Modal>
            ]}
          </PoseGroup>
        </div>
      );
    }
  }

  export default App